import Component from '@glimmer/component';

import { action } from '@ember/object';
import LinkToAction from 'ember-route-state/components/link-to-action.gjs';

import routeRefresh from 'rise-ui/utils/route-refresh.js';

export default class ReloadModelComponent extends Component {
  @action reloadModel() {
    routeRefresh(this);
  }

  <template>
    <LinkToAction @action={{this.reloadModel}} @linkClass={{@linkClass}}>{{yield}}</LinkToAction>
  </template>
}
